// 顶部

/*返回3D首页
 */
const volverA3D = {
  en: 'Back to 3D home page',
  zhCn: '返回3D首页',
  zhTn: '返回3D首頁',
  es: 'Volver a 3D'
}

/*登录
 */
const login = {
  en: 'Sign in',
  zhCn: '登录',
  zhTn: '登錄',
  es: 'Entrada'
}

/*购物车
 */
const shoppingCart = {
  en: 'Shopping Cart',
  zhCn: '购物车',
  zhTn: '購物車',
  es: 'Carro de compras'
}

//浏览器
const client = {
  en: 'Browser',
  zhCn: '浏览器',
  zhTn: '瀏覽器',
  es: 'Navegador'
}

//会员
const addressBook = {
  en: 'member',
  zhCn: '会员',
  zhTn: '會員',
  es: 'Miembros'
}

//下载
const updates = {
  en: 'download',
  zhCn: '下载',
  zhTn: '下載',
  es: 'Descargar'
}

/*智能三宝客户端浏览器
 */
const intelligentHumanClient = {
  en: 'Intelligent human client',
  zhCn: '智能三宝客户端浏览器',
  zhTn: '智能三寶客戶端瀏覽器',
  es: 'Cliente inteligente'
}

/*智三宝客户端浏览器
 */
const intelligentHomoClient = {
  en: 'Homo client',
  zhCn: '智三宝客户端浏览器',
  zhTn: '智三寶客戶端瀏覽器',
  es: 'Cliente Homo'
}

/*公有云客户端浏览器
 */
const outreachClient = {
  en: 'Outreach client',
  zhCn: '公有云客户端浏览器',
  zhTn: '公有雲客戶端瀏覽器',
  es: 'Cliente de divulgación'
}

/**
 *APP客户端浏览器
 */

const applicationClient = {
  en: 'Application client',
  zhCn: 'APP客户端浏览器',
  zhTn: 'APP客戶端瀏覽器',
  es: 'Cliente de aplicación'
}

/**
 *设备客户端浏览器
 */

const deviceClient = {
  en: 'Device client',
  zhCn: '设备客户端浏览器',
  zhTn: '設備客戶端瀏覽器',
  es: 'Cliente de dispositivo'
}

/**
 *私有云客户端浏览器
 */

const windowClient = {
  en: 'Window client',
  zhCn: '私有云客户端浏览器',
  zhTn: '私有雲客戶端瀏覽器',
  es: 'Cliente de ventana'
}

/**
 *智能邮箱浏览器
 */

const smartMailboxClient = {
  en: 'Smart mailbox client',
  zhCn: '智能邮箱浏览器',
  zhTn: '智能郵箱瀏覽器',
  es: 'Cliente de correo inteligente'
}

/**
 *商圈场景浏览器
 */

const businessSceneClient = {
  en: 'Business district scene client',
  zhCn: '商圈场景浏览器',
  zhTn: '商圈場景瀏覽器',
  es: 'Cliente de escenarios de Negocios'
}

/**
 *平台场景浏览器
 */
const platformScenarioClient = {
  en: 'Platform scenario client',
  zhCn: '平台场景浏览器',
  zhTn: '平臺場景瀏覽器',
  es: 'Cliente de escenario de plataforma'
}

/**
 * 应用场景浏览器
 */
const applicationScenarioClient = {
  en: 'Application scenario client',
  zhCn: '应用场景浏览器',
  zhTn: '應用場景瀏覽器',
  es: 'Cliente de escenarios de aplicación'
}

/**
 * 文件加密浏览器
 */

const mobileDesktopClient = {
  en: 'File encryption browser',
  zhCn: '文件加密浏览器',
  zhTn: '文件加密瀏覽器',
  es: 'Navegador de cifrado de archivos'
}

/**
 * 客户端下载
 */
const clientDownLoad = {
  en: 'Browser client',
  zhCn: '客户端下载',
  zhTn: '客戶端下載',
  es: 'Cliente del navegador'
}

/**
 * 刷一刷
 */
const extendedMetaverse = {
  en: 'find',
  zhCn: '发现',
  zhTn: '發現',
  es: 'Hallazgo'
}

/**
 * 下级智能人
 */
const downloadSmartPeople = {
  en: 'Subordinate intelligent person',
  zhCn: '下级智能人',
  zhTn: '下級智慧人',
  es: 'Personas inteligentes de nivel inferior'
}

/**
 * 操作指导
 */
const xiaoyuanMedia = {
  en: 'Operation guidance',
  zhCn: '操作指导',
  zhTn: '操作指導',
  es: 'Orientación operativa'
}

/**
 * 我的官网
 */
const myProfile = {
  en: 'My official website',
  zhCn: '我的官网',
  zhTn: '我的官網',
  es: 'Mi sitio web oficial'
}

/**
 * 精准推送
 */
const accuratePush = {
  en: 'Accurate push',
  zhCn: '精准推送',
  zhTn: '精准推送',
  es: 'Empuje preciso'
}

/**
 * 生态模型
 */
const EcologicalModelling = {
  en: 'Ecological Modelling',
  zhCn: '生态模型',
  zhTn: '生態模型',
  es: 'Modelo ecológico'
}

/**
 * 数字人体验
 */
const TheDigitalHuman = {
  en: 'The Digital Human',
  zhCn: '数字人体验',
  zhTn: '數字人体验',
  es: 'Hombre digital'
}

/**
 * 共享世界
 */
const IntelligentReformTutorial = {
  en: 'In the era of intelligence',
  zhCn: '共享世界',
  zhTn: '共享世界',
  es: 'La era de la inteligencia'
}

/**
 * 操作系统
 */
const aboutTheMetaverse = {
  en: 'Operating System',
  zhCn: '操作系统',
  zhTn: '作業系統',
  es: 'Tutorial del sistema'
}

/**
 * 机器人教程
 */
const RobotTutorial = {
  en: 'Dialogue robot',
  zhCn: '机器人教程',
  zhTn: '機器人教程',
  es: 'Robot de diálogo'
}

/**
 * 创建元宇宙
 */
const createBoot = {
  en: 'Create Boot',
  zhCn: '创建元宇宙',
  zhTn: '創建元宇宙',
  es: 'Crear guía'
}

/**
 * 元宇宙知识
 */
const scriptGuidance = {
  en: 'Metaverse knowledge',
  zhCn: '元宇宙知识',
  zhTn: '元宇宙知識',
  es: 'El conocimiento del Meta - universo'
}

/**
 * 操作手册
 */
const operatingManual = {
  en: 'operating manual',
  zhCn: '操作手册',
  zhTn: '操作手册',
  es: 'Manual de Operaciones'
}

/**
 * 社交管理
 */
const dataAssets = {
  en: 'Social management',
  zhCn: '社交管理',
  zhTn: '社交管理',
  es: 'Gestión Social'
}

/*智能三宝客户端浏览器下载
 */
const intelligentHumanClientDownLoad = {
  en: 'Intelligent human client',
  zhCn: '智能三宝客户端浏览器下载',
  zhTn: '智能三寶客戶端瀏覽器下載',
  es: 'Cliente inteligente'
}

/*智三宝客户端浏览器下载
 */
const intelligentHomoClientDownLoad = {
  en: 'Homo client',
  zhCn: '智三宝客户端浏览器下载',
  zhTn: '智三寶客戶端瀏覽器下載',
  es: 'Cliente Homo'
}

/*公有云客户端浏览器下载
 */
const outreachClientDownLoad = {
  en: 'Outreach client',
  zhCn: '公有云客户端浏览器下载',
  zhTn: '公有雲客戶端瀏覽器下載',
  es: 'Cliente de divulgación'
}

/*APP客户端浏览器下载
 */
const applicationClientDownLoad = {
  en: 'Application client',
  zhCn: 'APP客户端浏览器下载',
  zhTn: 'APP客戶端瀏覽器下載',
  es: 'Cliente de aplicación'
}

/*设备客户端浏览器下载
 */
const deviceClientDownLoad = {
  en: 'Device client',
  zhCn: '设备客户端浏览器下载',
  zhTn: '設備客戶端瀏覽器下載',
  es: 'Cliente de dispositivo'
}

/*私有云客户端浏览器下载
 */
const windowClientDownLoad = {
  en: 'Window client',
  zhCn: '私有云客户端浏览器下载',
  zhTn: '私有雲客戶端瀏覽器下載',
  es: 'Cliente de ventana'
}

/*智能邮箱浏览器下载
 */
const smartMailboxClientDownLoad = {
  en: 'Smart mailbox client',
  zhCn: '智能邮箱浏览器下载',
  zhTn: '智能郵箱瀏覽器下載',
  es: 'Cliente de correo inteligente'
}

/*商圈场景浏览器下载
 */
const businessSceneClientDownLoad = {
  en: 'Business district scene client',
  zhCn: '商圈场景浏览器下载',
  zhTn: '商圈場景瀏覽器下載',
  es: 'Cliente de escenarios de Negocios'
}

/*平台场景浏览器下载
 */
const platformScenarioClientDownLoad = {
  en: 'Platform scenario client',
  zhCn: '平台场景浏览器下载',
  zhTn: '平臺場景瀏覽器下載',
  es: 'Cliente de escenario de plataforma'
}

/*应用场景浏览器下载
 */
const applicationScenarioClientDownLoad = {
  en: 'Application scenario client',
  zhCn: '应用场景浏览器下载',
  zhTn: '應用場景瀏覽器下載',
  es: 'Cliente de escenarios de aplicación'
}

/*文件加密浏览器下载
 */
const mobileDesktopClientDownLoad = {
  en: 'File encryption browser download',
  zhCn: '文件加密浏览器下载',
  zhTn: '文件加密瀏覽器下載',
  es: 'Descarga del navegador de cifrado de archivos'
}

/*注册
 */
const register = {
  en: 'register',
  zhCn: '注册',
  zhTn: '註冊',
  es: 'Registro'
}

/*扫码注册
 */
const Scancodetoregister = {
  en: 'Scan code to register',
  zhCn: '扫码注册',
  zhTn: '掃碼注册',
  es: 'Registro de código de escaneo'
}
/*分享注册
 */
const shareRegister = {
  en: 'Share Registration',
  zhCn: '分享注册',
  zhTn: '分享註冊',
  es: 'Registro compartido'
}
/*退出
 */
const logOut = {
  en: 'Log out',
  zhCn: '退出',
  zhTn: '退出',
  es: 'Salida del registro'
}

/*多语言m
 */
const multilingualism = {
  en: 'Multilingualism',
  zhCn: '多语言',
  zhTn: '多語言',
  es: 'Multilingüismo M.'
}
/*网站导航
 */
const websiteNavigation = {
  en: 'Browser',
  zhCn: '浏览器',
  zhTn: '瀏覽器',
  es: 'Navegador'
}

// 底部

/*服务热线
 */
const serviceHotline = {
  en: 'Service hotline',
  zhCn: '服务热线',
  zhTn: '服務熱線',
  es: 'Línea de servicio'
}

/*联系方式
 */
const contactAddress = {
  en: 'Contact information',
  zhCn: '联系方式',
  zhTn: '聯系方式',
  es: 'Datos de contacto'
}

/*手机
 */
const telephone = {
  en: 'mobile phone',
  zhCn: '手机',
  zhTn: '手機',
  es: 'Teléfono móvil'
}

/*邮箱
 */
const mailbox = {
  en: 'mailbox',
  zhCn: '邮箱',
  zhTn: '郵箱',
  es: 'Buzón'
}

/*地址
 */
const address = {
  en: 'address',
  zhCn: '地址',
  zhTn: '地址',
  es: 'Dirección'
}

/*顶层机器人
 */
const MyMetaverse = {
  en: 'Top level robot',
  zhCn: '顶层机器人',
  zhTn: '頂層機器人',
  es: 'Robot de alto nivel'
}

/*培训指导
 */
const trainingGuidance = {
  en: 'Training guidance',
  zhCn: '培训指导',
  zhTn: '培訓指導',
  es: 'Orientación en materia de capacitación'
}

/*代理等级
 */
const Agentlevel = {
  en: 'Robot promotion',
  zhCn: '机器人推广',
  zhTn: '機器人推廣',
  es: 'Promoción de robots'
}

/*自营世界
 */
const SharedWorldConfiguration = {
  en: 'Self operated world',
  zhCn: '自营世界',
  zhTn: '自營世界',
  es: 'Mundo autónomo'
}

/*共享商城配置
 */
const SharedMallConfiguration = {
  en: 'Shared Mall Configuration',
  zhCn: '共享商城配置',
  zhTn: '共亯商城配寘',
  es: 'Configuración del centro comercial compartido'
}

/*好友圈
 */
const friendCircle = {
  en: 'Friend circle',
  zhCn: '好友圈',
  zhTn: '好友圈',
  es: 'Círculo de amigos'
}

/*我的名片
 */
const Mybusinesscard = {
  en: 'My business card',
  zhCn: '我的名片',
  zhTn: '我的名片',
  es: 'Mi tarjeta de visita'
}

/*社交论坛
 */
const Myofficialwebsite = {
  en: 'Social Forum',
  zhCn: '社交论坛',
  zhTn: '社交論壇',
  es: 'Foros Sociales'
}
/*数据市场
 */
const datamarket = {
  en: 'data market',
  zhCn: '数据市场',
  zhTn: '數據市場',
  es: 'Mercado de datos'
}
/*数字货币
 */
const digitalcurrency = {
  en: 'digital currency',
  zhCn: '数字货币',
  zhTn: '數位貨幣',
  es: 'Moneda digital'
}
/*代理等级
 */
const Yuanqivalue = {
  en: 'Yuanqi value',
  zhCn: '元气值',
  zhTn: '元氣值',
  es: 'Valor de la vitalidad'
}
/*刷一刷
 */
const BrushOnce = {
  en: 'Yuanqi value',
  zhCn: '刷一刷',
  zhTn: '刷一刷',
  es: 'Cepilla un cepillo'
}
/*看一看
 */
const TakeALook = {
  en: 'take a look',
  zhCn: '看一看',
  zhTn: '看一看',
  es: 'Echa un vistazo'
}
/*聊一聊
 */
const LetATalk = {
  en: 'Let a talk',
  zhCn: '聊一聊',
  zhTn: '聊一聊',
  es: 'Habla un poco'
}
/*好友圈
 */
const FriendCircle = {
  en: 'Yuanqi value',
  zhCn: '好友圈',
  zhTn: '好友圈',
  es: 'Círculo de amigos'
}
/*抖变世界
 */
const transformWorld = {
  en: 'Yuanqi value',
  zhCn: '抖变世界',
  zhTn: '抖變世界',
  es: 'Sacudir el mundo'
}
/*智能直播
 */
const IntelligentLive = {
  en: 'Yuanqi value',
  zhCn: '智能直播',
  zhTn: '智慧直播',
  es: 'Transmisión inteligente en vivo'
}

var allLanguageTagList = {
  volverA3D,
  login,
  updates,
  shoppingCart,
  register,
  logOut,
  shareRegister,
  Scancodetoregister,
  client,
  intelligentHomoClient,
  intelligentHumanClient,
  outreachClient,
  applicationClient,
  deviceClient,
  windowClient,
  smartMailboxClient,
  businessSceneClient,
  platformScenarioClient,
  applicationScenarioClient,
  mobileDesktopClient,
  clientDownLoad,
  intelligentHumanClientDownLoad,
  intelligentHomoClientDownLoad,
  outreachClientDownLoad,
  applicationClientDownLoad,
  deviceClientDownLoad,
  windowClientDownLoad,
  smartMailboxClientDownLoad,
  businessSceneClientDownLoad,
  platformScenarioClientDownLoad,
  applicationScenarioClientDownLoad,
  mobileDesktopClientDownLoad,
  multilingualism,
  websiteNavigation,
  serviceHotline,
  contactAddress,
  telephone,
  mailbox,
  address,
  extendedMetaverse,
  downloadSmartPeople,
  xiaoyuanMedia,
  myProfile,
  EcologicalModelling,
  TheDigitalHuman,
  IntelligentReformTutorial,
  aboutTheMetaverse,
  createBoot,
  dataAssets,
  addressBook,
  scriptGuidance,
  MyMetaverse,
  operatingManual,
  Agentlevel,
  RobotTutorial,
  SharedWorldConfiguration,
  SharedMallConfiguration,
  friendCircle,
  Mybusinesscard,
  Myofficialwebsite,
  datamarket,
  digitalcurrency,
  Yuanqivalue,
  BrushOnce,
  TakeALook,
  LetATalk,
  FriendCircle,
  transformWorld,
  IntelligentLive,
  accuratePush,
  trainingGuidance
}

export function getTagsByLanguage(lan) {
  var newObj = {}
  for (let i in allLanguageTagList) {
    newObj[i] = allLanguageTagList[i][lan]
  }
  return newObj
}



// WEBPACK FOOTER //
// ./src/language.js